import { render } from "./ResourceYearRange.vue?vue&type=template&id=2204923c"
import script from "./ResourceYearRange.vue?vue&type=script&lang=js"
export * from "./ResourceYearRange.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__